export var UserType;
(function (UserType) {
    UserType["USER"] = "USER";
    UserType["VISITOR"] = "VISITOR";
    UserType["API_CLIENT"] = "API_CLIENT";
})(UserType || (UserType = {}));
//# sourceMappingURL=user-type.enum.js.map